import produce from "immer";

import { SearchPolicy } from "../../../api/policy";
import { ModelState } from "../../../interfaces/modelState";

export interface AddressSearchData {
  postalCode?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
}

export interface PersonSearchData {
  inserts?: string;
  lastName?: string;
  dateOfBirth?: string;
}

export interface PolicyNumberSearchData {
  policyNumber?: string;
}

export type SearchOption = "address" | "person" | "policyNumber";

interface State {
  data?: SearchPolicy[];
  loading: boolean;
  modelState: ModelState | null;
  addressSearchData: AddressSearchData;
  personSearchData: PersonSearchData;
  policyNumberSearchData: PolicyNumberSearchData;
  searchOption: SearchOption;
}

export const initialState: State = {
  loading: false,
  modelState: null,
  data: undefined,
  addressSearchData: {
    postalCode: "",
    houseNumber: "",
    houseNumberAddition: undefined,
  },
  personSearchData: {
    inserts: undefined,
    lastName: "",
    dateOfBirth: "",
  },
  policyNumberSearchData: {
    policyNumber: "",
  },
  searchOption: "address",
};

type Action =
  | { type: "FETCH_DATA" }
  | { type: "FETCH_SUCCESS"; payload: { data: { policies: SearchPolicy[]; dictionary: Record<string, string> } } }
  | { type: "FETCH_ERROR"; payload: { modelState: ModelState } }
  | { type: "UPDATE_SEARCH_OPTION"; payload: SearchOption }
  | { type: "UPDATE_ADDRESS_SEARCH_DATA"; payload: Partial<AddressSearchData> }
  | { type: "UPDATE_PERSON_SEARCH_DATA"; payload: Partial<PersonSearchData> }
  | { type: "UPDATE_POLICY_NUMBER_SEARCH_DATA"; payload: Partial<PolicyNumberSearchData> };

export const searchDupDlpPolicyReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "FETCH_DATA":
      return produce(state, (draft) => {
        draft.loading = true;
        draft.modelState = null;
      });
    case "FETCH_SUCCESS":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = null;
        draft.data = action.payload.data.policies.map((p) => ({
          ...p,
          insurance: action.payload.data.dictionary[p.insurance] ?? p.insurance,
          role: action.payload.data.dictionary[p.role] ?? p.role,
        }));
      });
    case "FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload.modelState;
        draft.data = [];
      });
    case "UPDATE_SEARCH_OPTION":
      return produce(state, (draft) => {
        draft.modelState = null;
        draft.searchOption = action.payload;
      });
    case "UPDATE_ADDRESS_SEARCH_DATA":
      return produce(state, (draft) => {
        draft.addressSearchData = { ...draft.addressSearchData, ...action.payload };
      });
    case "UPDATE_PERSON_SEARCH_DATA":
      return produce(state, (draft) => {
        draft.personSearchData = { ...draft.personSearchData, ...action.payload };
      });
    case "UPDATE_POLICY_NUMBER_SEARCH_DATA":
      return produce(state, (draft) => {
        draft.policyNumberSearchData = { ...draft.policyNumberSearchData, ...action.payload };
      });
  }
};
